enum VtysGrupEnum {
    hastaKayitServisleri = 1,
    doktorTedaviServisleri = 2,
    kurumTanimlari = 3,
    raporTipleri = 4,
    depoTipleri = 5,
    patoloji = 6,
    radyoloji = 7,
    indirimTanimlari = 8,
}
export default VtysGrupEnum